export default {
  en: {
    currency: {
      style: 'currency',
      currency: 'AUD',
      currencyDisplay: 'symbol'
    },
    integer: {
      style: 'decimal'
    },
    percent: {
      style: 'percent',
      minimumFractionDigits: 2
    }
  }
}
